import React, { useState, useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import './Standings.css'
import StatsAndStandingsHome from '../../shared/components/Navigation/StatsAndStandingsHome'
import StatsAndStandingsHomeNavigation from '../../shared/components/Navigation/StatsAndStandingsHomeNavigation'
//import { useHttpClient } from '../../shared/hooks/http-hook'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import Modal from '../../shared/components/UIElements/Modal'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import mcdevittDivisions from '../../images/mcdevitt_divisions.JPG'
import sLogo from '../../images/s_logo_png.png'
import PopupAd from '../../shared/ads/PopupAd'
import useInApp from '../../shared/hooks/useInApp'

const Standings = () => {
	//const { sendRequest, clearError } = useHttpClient()
	const [error, setError] = useState()
	const [isLoading, setIsLoading] = useState(false)
	const [loadedStandings, setLoadedStandings] = useState()
	const [numberOfTeamsTotal, setNumberOfTeamsTotal] = useState()
	const [loadedStandingsArray, setLoadedStandingsArray] = useState([])
	const [leagueName, setLeagueName] = useState()
	const [divisionName, setDivisionName] = useState()
	const [session, setSession] = useState()
	const [year, setYear] = useState()
	const [masterArray, setMasterArray] = useState()
	const [pimAsTieBreaker, setPimAsTieBreaker] = useState()
	//
	const [showScoringMatrixModal, setShowScoringMatrixModal] = useState(false)
	const [showDivisionBreakdownModal, setShowDivisionBreakdownModal] =
		useState(false)
	const [pointsForAWin, setPointsForAWin] = useState()
	const [pointsForATie, setPointsForATie] = useState()
	const [pointsForAShutout, setPointsForAShutout] = useState()
	const [pointsForAnOvertimeLoss, setPointsForAnOvertimeLoss] = useState()
	const [maxPointsPerGame, setMaxPointsPerGame] = useState()
	const [tiebreakers, setTiebreakers] = useState()
	const [numberOfDivisions, setNumberOfDivisions] = useState()
	const [isCurrent, setIsCurrent] = useState()
	//const [returnArray, setReturnArray] = useState([])

	const { inWrapper } = useInApp()

	const leagueId = useParams().leagueId

	console.log('inside Standings')

	//call to getStandings in the league-controller
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/league/leagues/${leagueId}/standings`,
				)

				const responseData = await response.json()

				/* console.log(
					'responseData here: ' + JSON.stringify(responseData.listOfTeams)
				) */

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				if (responseData.listOfTeams[0].divisionName) {
					setDivisionName(responseData.listOfTeams[0].divisionName)
				} else {
					setDivisionName('')
				}

				/* console.log(
					'masterMasterArray: ' + JSON.stringify(responseData.masterMasterArray)
				) */

				//setMasterArray(responseData.masterMasterArray)
				setMasterArray(responseData.masterArray3)
				setLoadedStandings(responseData.listOfTeams)
				setNumberOfTeamsTotal(responseData.numberOfTeamsTotal)
				setLoadedStandingsArray(responseData.listOfTeamsArray)
				setLeagueName(responseData.leagueName)
				setSession(responseData.session)
				setPimAsTieBreaker(responseData.pimAsTieBreaker)
				setYear(responseData.year)
				setPointsForAWin(responseData.pointsForAWin)
				setPointsForATie(responseData.pointsForATie)
				setPointsForAShutout(responseData.pointsForAShutout)
				setPointsForAnOvertimeLoss(responseData.pointsForAnOvertimeLoss)
				setMaxPointsPerGame(responseData.maxPointsPerGame)
				setNumberOfDivisions(responseData.numberOfDivisions)
				setIsCurrent(responseData.isCurrent)
				setTiebreakers(responseData.tiebreakers)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [leagueId])

	/* if (!isLoading && masterArray) {
		console.log('masterArray: ' + JSON.stringify(masterArray))
	} */

	let numberOfTeams
	//numberOfTeams = loadedStandings && loadedStandings.length
	//console.log('numberOfTeams: ' + loadedStandings)

	numberOfTeams = numberOfTeamsTotal && numberOfTeamsTotal.length
	console.log('numberOfTeamsTotal: ' + numberOfTeamsTotal)

	//So, when masterArray comes to us from the backend, it can be a pretty long list
	//if there were many sets of two teams tied for points.  For example, if there were
	//four sets of two teams tied in points, this masterarray would be four times the
	//size we need.  However, the last of those four would be the correct version.
	//So, we reverse the long incoming array, then cut it (splice it) at however many
	//number of teams there are, then we reverse it again.
	masterArray && masterArray.reverse()
	//console.log('masterArray 1: ' + masterArray)
	masterArray && masterArray.splice(numberOfTeamsTotal)
	//console.log('masterArray 2: ' + masterArray)
	masterArray && masterArray.reverse()
	//console.log('masterArray 3: ' + masterArray)
	//masterArray &&
	//	console.log('fucking master array: ' + JSON.stringify(masterArray))
	let groupedArray
	groupedArray = []
	if (masterArray) {
		const uniqueDivisionsArray = masterArray.map((item) => item.divisionName)

		const toFindUniques = (arry) =>
			arry.filter((item, index) => arry.indexOf(item) === index)

		const uniques = toFindUniques(uniqueDivisionsArray)

		console.log(
			'there are ' + uniques.length + ' divisions.  They are ' + uniques,
		)

		if (uniques.length > 1) {
			console.log(
				'we have more than one division, lets split them up into separate arrays',
			)
			for (const element of uniques) {
				const item = masterArray.filter((el) => el.divisionName === element)
				groupedArray.push(item)
			}
			/* groupedArray.forEach((array, index) => {
				console.log('groupedArray ' + index + ': ' + JSON.stringify(array))
			}) */
		}
	}
	//
	//
	const openScoringMatrixModal = () => {
		setShowScoringMatrixModal(true)
	}

	const closeScoringMatrixModal = () => {
		setShowScoringMatrixModal(false)
	}

	const openDivisionBreakdownModal = () => {
		setShowDivisionBreakdownModal(true)
	}

	const closeDivisionBreakdownModal = () => {
		setShowDivisionBreakdownModal(false)
	}
	//
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	//
	//
	if (groupedArray && groupedArray.length < 1) {
		return (
			<React.Fragment>
				<PopupAd isInApp={inWrapper} />
				<StatsAndStandingsHome />
				<StatsAndStandingsHomeNavigation leagueId={leagueId} />
				<ErrorModal error={error} onClear={errorHandler} />
				{/* //
				//
				//    Scoring Matrix Modal
				//
				// */}
				<Modal
					show={showScoringMatrixModal}
					onCancel={closeScoringMatrixModal}
					header='Scoring Matrix'
					footer={
						<button
							onClick={closeScoringMatrixModal}
							style={{
								backgroundColor: '#edcb37',
								color: 'black',
								fontWeight: 'bold',
								border: 'none',
								padding: '0.6rem 2.5rem',
								borderRadius: '4px',
								cursor: 'pointer',
							}}
						>
							Close
						</button>
					}
				>
					<div style={{ lineHeight: '1.8' }}>
						<p>
							<strong>Points for a Win:</strong> {pointsForAWin}
						</p>
						<p>
							<strong>Points for a Tie:</strong> {pointsForATie}
						</p>
						<p>
							<strong>Points for a Shutout:</strong> {pointsForAShutout}
						</p>
						<p>
							<strong>Points for an Overtime Loss:</strong>{' '}
							{pointsForAnOvertimeLoss}
						</p>
						<p>
							<strong>1 point for each goal differential.</strong>
						</p>
						<p>
							<strong>Max Points Per Game:</strong> {maxPointsPerGame}
						</p>
						<p>
							<strong>Tie-breakers:</strong> {tiebreakers}
						</p>
					</div>
				</Modal>
				{/* //
				//
				//    Division Breakdown Modal
				//
				// */}
				<Modal
					show={showDivisionBreakdownModal}
					onCancel={closeDivisionBreakdownModal}
					header='Division Breakdown'
					footer={
						<button
							onClick={closeDivisionBreakdownModal}
							style={{
								backgroundColor: '#edcb37',
								color: 'black',
								fontWeight: 'bold',
								border: 'none',
								padding: '0.6rem 2.5rem',
								borderRadius: '4px',
								cursor: 'pointer',
							}}
						>
							Close
						</button>
					}
				>
					<div className='division-breakdown-modal'>
						<p>
							<strong>
								Teams are locked into the following divisions. Their points will
								determine their placement within these divisions:
							</strong>
						</p>

						<img
							src={mcdevittDivisions}
							alt='McDevitt Cup division breakdown'
							className='division-breakdown-image'
						/>
					</div>
				</Modal>
				{isLoading && (
					<div className='center'>
						<LoadingSpinner />
					</div>
				)}
				{!isLoading && masterArray && (
					<div className='Roster'>
						<h1>Tournament Standings</h1>
						<h1>
							{leagueName} {divisionName && ' - ' + divisionName + ' Division'}
						</h1>
						<h2>
							{session} {year}
						</h2>
						<p style={{ textAlign: 'center' }}>
							(Click on a team to go to their roster and schedule page)
						</p>
						<table
							id='roster'
							className='standingsDivisionTable'
							cellSpacing={'0'}
							cellPadding={'0'}
						>
							<thead>
								<tr>
									<th>Team</th>
									<th>GP</th>
									<th>W</th>
									<th>L</th>
									<th>T</th>
									<th>OTL</th>
									{/* <th>OTL</th>
									<th>SOL</th> */}
									<th>GF</th>
									<th>GA</th>
									<th>GD</th>
									{pimAsTieBreaker && <th>PIM</th>}
									<th>Points</th>
									<th>%</th>
								</tr>
							</thead>
							<tbody>
								{masterArray.map((team, key) => {
									return (
										<tr key={key}>
											<td className='tableDataTeamName'>
												<Link
													style={{
														textDecoration: 'none',
														color: 'black',
														fontWeight: 600,
													}}
													to={`${team.divisionName}/${year}/${team.teamName}`}
												>
													{team.teamName}
												</Link>
											</td>
											<td>
												{team.wins +
													team.losses +
													team.ties +
													team.shootoutLosses +
													team.overtimeLosses}
											</td>
											<td>{team.wins}</td>
											<td>{team.losses}</td>
											<td>{team.ties}</td>
											<td>{team.overtimeLosses}</td>
											{/* <td>{team.overtimeLosses}</td>
											<td>{team.shootoutLosses}</td> */}
											<td>{team.goalsFor}</td>
											<td>{team.goalsAgainst}</td>
											<td>{team.goalsFor - team.goalsAgainst}</td>
											{pimAsTieBreaker && <td>{team.pim}</td>}
											<td>{team.points}</td>
											<td>
												{!isNaN(
													Number(
														(team.wins + team.ties * 0.5) /
															(team.wins +
																team.losses +
																team.overtimeLosses +
																team.shootoutLosses +
																team.ties),
													).toFixed(3),
												) &&
													Number(
														(team.wins + team.ties * 0.5) /
															(team.wins +
																team.losses +
																team.overtimeLosses +
																team.shootoutLosses +
																team.ties),
													).toFixed(3)}
											</td>
										</tr>
									)
								})}
							</tbody>
						</table>
					</div>
				)}
				{!isLoading && !masterArray && (
					<div className='Standings'>
						<h1>
							{leagueName} {divisionName && divisionName} - Tournament Standings
						</h1>
						<h2>
							{session} {year}
						</h2>
						<table id='players' cellSpacing={'0'} cellPadding={'0'}>
							<thead>
								<tr>
									<th>Team</th>
									<th>GP</th>
									<th>W</th>
									<th>L</th>
									<th>T</th>
									<th>OTL</th>
									{/* <th>OTL</th>
									<th>SOL</th> */}
									<th>GF</th>
									<th>GA</th>
									{pimAsTieBreaker && <th>PIM</th>}
									<th>Points</th>
								</tr>
							</thead>
						</table>
					</div>
				)}
			</React.Fragment>
		)
	} else if (groupedArray && groupedArray.length > 0) {
		return (
			<React.Fragment>
				<PopupAd isInApp={inWrapper} />
				<StatsAndStandingsHome />
				<StatsAndStandingsHomeNavigation leagueId={leagueId} />
				<ErrorModal error={error} onClear={errorHandler} />
				{/* //
				//
				//    Scoring Matrix Modal
				//
				// */}
				<Modal
					show={showScoringMatrixModal}
					onCancel={closeScoringMatrixModal}
					header='Scoring Matrix'
					footer={
						<div style={{ textAlign: 'center' }}>
							<button
								onClick={closeScoringMatrixModal}
								style={{
									backgroundColor: '#edcb37',
									color: 'black',
									border: 'none',
									fontWeight: 'bold',
									padding: '0.6rem 2.5rem',
									borderRadius: '4px',
									cursor: 'pointer',
								}}
							>
								Close
							</button>
						</div>
					}
				>
					<div style={{ lineHeight: '1.8' }}>
						<p>
							<strong>Points for a Win:</strong> {pointsForAWin}
						</p>
						<p>
							<strong>Points for a Tie:</strong> {pointsForATie}
						</p>
						<p>
							<strong>Points for a Shutout:</strong> {pointsForAShutout}
						</p>
						<p>
							<strong>Points for an Overtime Loss:</strong>{' '}
							{pointsForAnOvertimeLoss}
						</p>
						<p>
							<strong>1 point for each goal differential.</strong>
						</p>
						<p>
							<strong>Max Points Per Game:</strong> {maxPointsPerGame}
						</p>
						<p>
							<strong>Tie-breakers:</strong> {tiebreakers}
						</p>
					</div>
				</Modal>
				{/* //
				//
				//    Division Breakdown Modal
				//
				// */}
				<Modal
					show={showDivisionBreakdownModal}
					onCancel={closeDivisionBreakdownModal}
					header='Division Breakdown'
					footer={
						<button
							onClick={closeDivisionBreakdownModal}
							style={{
								backgroundColor: '#edcb37',
								color: 'black',
								fontWeight: 'bold',
								border: 'none',
								padding: '0.6rem 2.5rem',
								borderRadius: '4px',
								cursor: 'pointer',
							}}
						>
							Close
						</button>
					}
				>
					<div className='division-breakdown-modal'>
						<p>
							<strong>
								Teams are locked into the following divisions. Their points will
								determine their placement within these divisions:
							</strong>
						</p>

						<img
							src={mcdevittDivisions}
							alt='McDevitt Cup division breakdown'
							className='division-breakdown-image'
						/>
					</div>
				</Modal>
				{isLoading && (
					<div className='center'>
						<LoadingSpinner />
					</div>
				)}
				<div className='standingsDesktopHeader'>
					<h2>
						{year} {leagueName}
					</h2>
				</div>

				<div className='standingsMobileHero'>
					<div className='standingsHeroTop'>
						<div className='standingsHeroLine'></div>

						<div className='standingsHeroLogoCircle'>
							<img src={sLogo} alt='Shirey logo' />
						</div>

						<div className='standingsHeroLine'></div>
					</div>

					<h1>Standings</h1>

					<div className='standingsHeroPill'>
						{year} {leagueName}
					</div>
				</div>

				<div className='standingsScoringMatrix'>
					<span onClick={openScoringMatrixModal}>Scoring Matrix</span>
				</div>

				<p className='standingsHelperText'>
					(Click on a team name to see their schedule.)
				</p>
				{/* <h1>More than one group here. {groupedArray.length}</h1> */}
				{groupedArray.map((group, key) => {
					return (
						<div className='Roster'>
							<h4 className='standingsDivisionTitle'>
								<span>{group[0].divisionName} Division</span>
							</h4>
							{leagueName === 'McDevitt Cup' && (
								<div style={{ textAlign: 'center', marginBottom: '1rem' }}>
									<button
										onClick={openDivisionBreakdownModal}
										className='divisionBreakdownButton'
									>
										Division Breakdown
									</button>
								</div>
							)}
							<table
								id='roster'
								className='standingsDivisionTable'
								cellSpacing={'0'}
								cellPadding={'0'}
							>
								<thead>
									<tr>
										<th>Team</th>
										<th>GP</th>
										<th>W</th>
										<th>L</th>
										<th>T</th>
										<th>OTL</th>
										{/* <th>OTL</th>
										<th>SOL</th> */}
										<th>GF</th>
										<th>GA</th>
										<th>GD</th>
										{pimAsTieBreaker && <th>PIM</th>}
										<th>Points</th>
										<th>%</th>
									</tr>
								</thead>
								<tbody>
									{group.map((team, key) => {
										// return <h1>{team.teamName}</h1>
										return (
											<tr key={key}>
												<td className='tableDataTeamName'>
													<Link
														style={{
															textDecoration: 'none',
															color: 'black',
															fontWeight: 600,
														}}
														to={`/league/teamSchedule/${team._id}`}
													>
														{team.teamName}
													</Link>
												</td>
												{/* <td className='tableDataTeamName'>{team.teamName}</td> */}
												<td>
													{team.wins +
														team.losses +
														team.ties +
														team.shootoutLosses +
														team.overtimeLosses}
												</td>
												<td>{team.wins}</td>
												<td>{team.losses}</td>
												<td>{team.ties}</td>
												<td>{team.overtimeLosses}</td>
												{/* <td>{team.overtimeLosses}</td>
												<td>{team.shootoutLosses}</td> */}
												<td>{team.goalsFor}</td>
												<td>{team.goalsAgainst}</td>
												<td>{team.goalsFor - team.goalsAgainst}</td>
												{pimAsTieBreaker && <td>{team.pim}</td>}
												<td>{team.points}</td>
												<td>
													{!isNaN(
														Number(
															(team.wins + team.ties * 0.5) /
																(team.wins +
																	team.losses +
																	team.overtimeLosses +
																	team.shootoutLosses +
																	team.ties),
														).toFixed(3),
													) &&
														Number(
															(team.wins + team.ties * 0.5) /
																(team.wins +
																	team.losses +
																	team.overtimeLosses +
																	team.shootoutLosses +
																	team.ties),
														).toFixed(3)}
												</td>
											</tr>
										)
									})}
								</tbody>
							</table>
						</div>
					)
				})}
			</React.Fragment>
		)
	}
}

export default Standings
